import React from 'react';
import { RefreshIcon } from 'icons';
import { useTranslations } from 'next-intl';

interface IProps {
  fetchNextPage: () => void;
  isFetchingNextPage?: boolean;
}

const LoadMoreButton: React.FC<IProps> = ({ fetchNextPage, isFetchingNextPage }) => {
  const t = useTranslations();

  return (
    <div className="mt-5 flex justify-center">
      <button
        onClick={() => fetchNextPage()}
        disabled={isFetchingNextPage}
        className="flex cursor-pointer items-center gap-2 rounded-xl bg-green-600 px-4 py-2 text-white"
      >
        <RefreshIcon />
        {isFetchingNextPage ?   `${t('yuklanmoqda')}...` : t('yana_yuklash')}
      </button>
    </div>
  );
};

export default LoadMoreButton;
